import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { useRef, forwardRef } from "react";
import { B as Button } from "./Button-BduN4i4I.js";
import { F as Flex } from "./Flex-BqkSIn_m.js";
import { B as Box } from "./Grid-CcQKdsgp.js";
import { P as Popover } from "./Popover-B1B60g-t.js";
import { T as Typography } from "./Typography-BcQZigNB.js";
import { useOption, useListBox } from "@react-aria/listbox";
import { useSelectState } from "@react-stately/select";
import { useSelect, HiddenSelect } from "@react-aria/select";
import { Item } from "@react-stately/collections";
const SvgArrowDown = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 8,
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#fff",
        fillOpacity: 0.5,
        fillRule: "evenodd",
        d: "M.793 1.043a1 1 0 0 1 1.414 0L6 4.836l3.793-3.793a1 1 0 0 1 1.414 1.414l-4.5 4.5a1 1 0 0 1-1.414 0l-4.5-4.5a1 1 0 0 1 0-1.414",
        clipRule: "evenodd"
      }
    )
  }
);
const SelectOption = function({
  item,
  state
}) {
  const ref = useRef(null);
  const { optionProps, isDisabled } = useOption({ key: item.key }, state, ref);
  return /* @__PURE__ */ jsx(
    Box,
    {
      as: "li",
      ref,
      bg: isDisabled ? "surface-neutral-subtle" : "background-transparent",
      className: `cursor-pointer outline-none`,
      ...optionProps,
      style: { padding: 10 },
      onClick: () => state.selectionManager.toggleSelection(item.key),
      children: /* @__PURE__ */ jsx(Typography, { color: "text-primary-default", children: item.rendered })
    }
  );
};
const SelectOptionList = forwardRef(function(props, ref) {
  const localRef = useRef(null);
  const listBoxRef = ref != null ? ref : localRef;
  const { state, minWidth = "auto", maxWidth = "auto" } = props;
  const { listBoxProps } = useListBox(
    props,
    state,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    listBoxRef
  );
  return /* @__PURE__ */ jsx(
    "ul",
    {
      ...listBoxProps,
      ref: listBoxRef,
      style: { width: "100%", padding: 0, margin: 0, minWidth, maxWidth },
      className: `bg-[var(--colors-background-transparent)] rounded overflow-hidden ${props.className}`,
      children: [...state.collection].map((item) => /* @__PURE__ */ jsx(SelectOption, { item, state }, item.key))
    }
  );
});
const Select = function(props) {
  var _a;
  let items = props.items;
  const isElementary = typeof items[0] === "string" || typeof items[0] === "number";
  if (isElementary) {
    items = items.map((item) => ({ id: item }));
  }
  const onSelectionChange = (key) => {
    const value = JSON.parse(String(key));
    props.onChange(
      isElementary ? value.id : value
    );
  };
  const opts = {
    ...props,
    items,
    onSelectionChange,
    children: (item) => {
      var _a2, _b;
      const value = isElementary ? (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        item.id
      ) : (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        (_b = (_a2 = props.getOptionLabel) == null ? void 0 : _a2.call(props, item)) != null ? _b : String(item.name)
      );
      return /* @__PURE__ */ jsx(Item, { children: String(value) }, JSON.stringify(item));
    }
  };
  const state = useSelectState(opts);
  const ref = useRef(null);
  const { triggerProps, menuProps } = useSelect(opts, state, ref);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      HiddenSelect,
      {
        isDisabled: props.disabled,
        state,
        triggerRef: ref,
        label: props.emptyText,
        name: props.name
      }
    ),
    /* @__PURE__ */ jsx(
      Button,
      {
        className: `${props.className}`,
        size: "small",
        variant: "secondary",
        ...triggerProps,
        ref,
        p: { px: 12, py: 10 },
        minWidth: props.minWidth,
        maxWidth: props.maxWidth,
        onPress: () => {
          if (!state.isOpen) {
            state.toggle();
          }
        },
        children: /* @__PURE__ */ jsxs(Flex, { width: "100%", gap: 10, align: "center", justify: "space-between", children: [
          state.selectedItem ? state.selectedItem.rendered : (_a = props.emptyText) != null ? _a : "Select an option",
          /* @__PURE__ */ jsx(SvgArrowDown, { width: "12", height: "8", viewBox: "0 0 12 8" })
        ] })
      }
    ),
    state.isOpen && /* @__PURE__ */ jsx(Popover, { state, triggerRef: ref, placement: "bottom start", children: /* @__PURE__ */ jsx(SelectOptionList, { minWidth: 162, ...menuProps, state }) })
  ] });
};
export {
  Select as S,
  SelectOption as a,
  SelectOptionList as b
};
